import {
  PRODUCTINVENTORYDETAIL_LOADING,
  GET_PRODUCTINVENTORYDETAIL,
  GET_PRODUCTINVENTORYDETAIL_SUCCESS,
  GET_PRODUCTINVENTORYDETAIL_FAIL,
  ADD_PRODUCTINVENTORYDETAIL_SUCCESS,
  ADD_PRODUCTINVENTORYDETAIL_FAIL,
  DELETE_PRODUCTINVENTORYDETAIL_SUCCESS,
  DELETE_PRODUCTINVENTORYDETAIL_FAIL,
  UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS,
  UPDATE_PRODUCTINVENTORYDETAIL_FAIL,
  PRODUCTINVENTORYDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  productInventoryDetails: [],
  error: {},
};

const ProductInventoryDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTINVENTORYDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORYDETAIL:
          return {
            ...state,
            productInventoryDetails: action.payload.data,
            isProductInventoryDetailCreated: false,
            isProductInventoryDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTINVENTORYDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORYDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductInventoryDetailCreated: false,
            isProductInventoryDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTINVENTORYDETAIL: {
      return {
        ...state,
        isProductInventoryDetailCreated: false,
        loading: true,
      };
    }

    case PRODUCTINVENTORYDETAIL_LOADING: {
      return {
        ...state,
        isProductInventoryDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTINVENTORYDETAIL_SUCCESS:
      return {
        ...state,
        isProductInventoryDetailCreated: true,
        loading: false,
        productInventoryDetails: [action.payload.data, ...state.productInventoryDetails],
      };

    case ADD_PRODUCTINVENTORYDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTINVENTORYDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryDetailCreated: true,
        productInventoryDetails: state.productInventoryDetails.filter(
          productInventoryDetail => productInventoryDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTINVENTORYDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTINVENTORYDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryDetailCreated: true,
        productInventoryDetails: state.productInventoryDetails.map(productInventoryDetail =>
          productInventoryDetail.id.toString() === action.payload.data.id.toString() ? { ...productInventoryDetail, ...action.payload.data } : productInventoryDetail
        ),
      };

    case UPDATE_PRODUCTINVENTORYDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTINVENTORYDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductInventoryDetail;